(() => {
  "use strict";
  if (globalThis.EasyUploadPresentation) return;
  globalThis.EasyUploadPresentation = !0;
  const configNode = document.querySelector(
    "[data-easy-upload-presentation-config]",
  );
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent),
    selector = "[data-easy-upload-slot], [data-easy-global-upload-slot]";
  function refresh() {
    (document.querySelectorAll("label[for]").forEach((label) => {
      document.getElementById(label.htmlFor)?.tagName === "TEXTAREA" &&
        label.textContent.trim() === "\u5907\u6CE8" &&
        (label.textContent =
          "\u5907\u6CE8\uFF08\u5EFA\u8BAE\u5199\u4E0A\u5FAE\u4FE1\u53F7\uFF0C\u65B9\u4FBF\u6838\u5BF9\uFF09");
    }),
      document.querySelectorAll(selector).forEach((row) => {
        if (row.closest("[data-easy-multi-version-upload]")) {
          row
            .querySelectorAll("[data-easy-upload-display-label]")
            .forEach((label) => label.remove());
          return;
        }
        const slot = Number(
          row.dataset.easyUploadSlot || row.dataset.easyGlobalUploadSlot,
        );
        if (!Number.isInteger(slot) || slot < 1) return;
        const scope =
            row.closest(
              "[data-easy-area-calculator], .product__info-container",
            ) || document,
          field = scope.querySelector("[data-easy-flyer-color]"),
          color = field
            ? field.value +
              " " +
              (field.selectedOptions?.[0]?.textContent || "")
            : "",
          doubleSided = /4\/4|双面|double|two.side/i.test(color),
          jobs = scope.querySelector("[data-easy-banner-jobs]"),
          text =
            config.handle === "standard-business-cards" &&
            doubleSided &&
            slot <= 2
              ? slot === 1
                ? config.front
                : config.back
              : (jobs ? config.artwork : config.file).replace(
                  "__NUMBER__",
                  String(slot),
                );
        let label = row.querySelector("[data-easy-upload-display-label]");
        (label ||
          ((label = document.createElement("strong")),
          (label.dataset.easyUploadDisplayLabel = ""),
          row.prepend(label)),
          label.textContent !== text && (label.textContent = text));
      }));
  }
  let scheduled = !1;
  function schedule() {
    scheduled ||
      ((scheduled = !0),
      requestAnimationFrame(() => {
        ((scheduled = !1), refresh());
      }));
  }
  (document.addEventListener("change", event => {
      if (event.target.matches?.('[data-easy-flyer-color]')) schedule();
    }),
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1))) schedule();
    }).observe(document.body, {
      childList: !0,
      subtree: !0,
    }),
    refresh());
})();
//# sourceMappingURL=/cdn/shop/t/11/assets/easy-upload-presentation.js.map?v=121398088944434765441791313965
